import styled from 'styled-components';
import InfoIconBase from '#/shared/components/GeneratedIcons/trimet/Info';
import CircleProgressbarBase from '#/shared/components/CircleProgressbar';

export const PromptWrapper = styled.div`
  display: inline-flex;
  flex: 1;
  flex-direction: column;
  padding: 10px;
  text-align: center;
  font-size: 1.2em;
`;

export const Description = styled.span`
  color: ${props => props.theme.secondaryFontColor};
  font-size: 1em;
`;

export const InfoIcon = styled(InfoIconBase).attrs(props => ({
  fill: props.theme.secondaryFontColor,
  width: 75,
  height: 75,
  role: 'img',
  title: 'Info Icon',
}))`
  display: flex;
  margin: 2em auto 1em;
  opacity: 0.5;
`;

export const Countdown = styled.div`
  display: flex;
  color: ${props => props.theme.secondaryFontColor};
  flex: 0;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 1em 0;
`;

export const CircleProgressbar = styled(CircleProgressbarBase).attrs(
  ({ theme }) => ({
    frontCircleColor: theme.vehicleTrackerHighlightColor,
    backCircleColor: theme.vehicleTrackerHighlightBackingColor,
  })
)``;
